// Scroll-cue atom — loads the scroll lottie and exposes reveal / unreveal commands.
// Call window.scrollCue.reveal() / unreveal(), optionally with a selector.

import lottie from 'imports/lottie-web'

const applyClass = (els, addCls, removeCls) => {
    els.forEach((el) => {
        el.classList.add(addCls)
        el.classList.remove(removeCls)
    })
}

const resolveTargets = (selector) => {
    if (!selector) return document.querySelectorAll('[data-scroll-cue]')
    return document.querySelectorAll(selector)
}

const scrollCue = {
    init() {
        document.querySelectorAll('[data-scroll-cue]').forEach((el) => {
            if (el._lottie) return
            const src = el.dataset.lottieSrc
            if (!src) return

            const instance = lottie.loadAnimation({
                container: el,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: src,
            })
            el._lottie = instance
        })
    },

    reveal(selector) {
        applyClass(resolveTargets(selector), 'is-revealed', 'is-unrevealed')
    },

    unreveal(selector) {
        applyClass(resolveTargets(selector), 'is-unrevealed', 'is-revealed')
    }
}

if (typeof window !== 'undefined') {
    window.scrollCue = scrollCue
}

export default scrollCue
